// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledText = void 0;

var _styledComponents = _interopRequireWildcard(require('../../styled-components'));

var _validation = require('../../utils/validation');

var _colors = require('../../utils/colors');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([
    '\n  ',
    '\n  font-size: ',
    ';\n  line-height: ',
    ';\n  @media screen and (min-width: ',
    ') {\n    font-size: ',
    ';\n    line-height: ',
    ';\n  }\n  @media screen and (min-width: ',
    ') {\n    font-size: ',
    ';\n    line-height: ',
    ';\n  }\n  @media screen and (min-width: ',
    ') {\n    font-size: ',
    ';\n    line-height: ',
    ';\n  }\n  @media screen and (min-width: ',
    ') {\n    font-size: ',
    ';\n    line-height: ',
    ';\n  }\n  @media screen and (min-width: ',
    ') {\n    font-size: ',
    ';\n    line-height: ',
    ';\n  }\n'
  ]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([
    '\n  display: ',
    ';\n  font-family: ',
    ';\n  text-align: ',
    ';\n  color: ',
    ';\n  font-weight: ',
    ';\n  margin-top: ',
    ';\n  margin-bottom: ',
    ';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ',
    '\n'
  ]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var baseStyles = (0, _styledComponents.css)(
  _templateObject(),
  function (props) {
    return props.display;
  },
  function (props) {
    return props.fontFamily;
  },
  function (props) {
    return props.align;
  },
  function (props) {
    return (
      props.color ||
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'defaultColors') &&
        (0, _colors.normaliseColor)(props.theme.typography.defaultColors, props.theme)) ||
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'colors') && props.theme.colors.primaryFont)
    );
  },
  function (props) {
    return props.fontWeight;
  },
  function (props) {
    return props.marginTop;
  },
  function (props) {
    return props.marginBottom || (props.tag === 'p' ? '3rem' : 0);
  },
  function (props) {
    return props.truncate && '\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ';
  }
);

var StyledText = _styledComponents.default.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return ![
      'display',
      'fontFamily',
      'align',
      'color',
      'fontWeight',
      'marginTop',
      'marginBottom',
      'truncate',
      'level'
    ].includes(prop);
  }
})(
  _templateObject2(),
  baseStyles,
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.xxs) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.xxs) ||
      ''
    );
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.xs;
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.xs) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.xs) ||
      ''
    );
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.sm;
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.sm) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.sm) ||
      ''
    );
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.md;
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.md) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.md) ||
      ''
    );
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.lg;
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.lg) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.lg) ||
      ''
    );
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.xl;
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.xl) ||
      ''
    );
  },
  function (props) {
    return (
      ((0, _validation.checkIfNestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.xl) ||
      ''
    );
  }
);

exports.StyledText = StyledText;
